import { call, put, delay } from "redux-saga/effects";
import { closeCaptionApi } from "@services/api";
import { getAllCloseCaptionActions } from "../slices";

function* getAllCloseCaptionWorker({ payload }) {
  yield delay(300);
  try {
    yield put(getAllCloseCaptionActions.pending());
    const response = yield call(closeCaptionApi.getAllCloseCaption, payload);
    yield put(getAllCloseCaptionActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(getAllCloseCaptionActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { getAllCloseCaptionWorker };
